import { Suspense, useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import CardStartMaintenance from "./vehicle-start-maintenance/CardStartMaintenance";
import VehicleStartMaintenanceDetails from "./vehicle-start-maintenance/VehicleStartMaintenanceDetails";
import CardEndMaintenance from "./vehicle-end-maintenance/vehicle-end-maintenance/CardEndMaintenance";
import VehicleEndMaintenanceDetails from "./vehicle-end-maintenance/vehicle-end-maintenance/VehicleEndMaintenanceDetails";
import { IMaintenanceVisualRecord } from "../../../../types/maintenance-visual-record.type";
import { FaPencil } from "react-icons/fa6";
import ModalForecastMaintenanceEdit from "./modals/ModalEditForecastMaintenance";
import { AuthContext } from "../../../../common/components/auth/authContext/AuthContext";
import { IMaintenance } from "@/types/maintenance.type";

type VehicleCardProps = {
  vehicleRecord: IMaintenanceVisualRecord;
  isFirstRecord: boolean;
  setHasUpdated: (boolean) => void;
  maintenances: IMaintenance[]
};

export default function VehicleMaintenanceCard({
  vehicleRecord,
  isFirstRecord,
  setHasUpdated,
  maintenances
}: VehicleCardProps) {
  const vehicleData = vehicleRecord;
  const renterUrl = `/clientes/${vehicleRecord.renterId}`;
  const [showStartDetails, setShowStartDetails] = useState(false);
  const [showEndDetails, setShowEndDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const authCtx = useContext(AuthContext);
  const permissions = authCtx.auth?.user?.permissions;

  const handleToggleDelivered = () => {
    setShowStartDetails(!showStartDetails);
  };

  const handleToggleEnd = () => {
    setShowEndDetails(!showEndDetails);
  };

  const handleCloseStartMaintenance = () => {
    setShowStartDetails(false);
  };

  const handleCloseEndMaintenance = () => {
    setShowEndDetails(false);
  };

  return (
    <section>
      <div className="flex flex-col bg-gray/20 rounded p-2 mx-3 justify-evelyn items-center">
        <h2 className="text-2xl font-semibold mb-4 text-center ">
          {isFirstRecord ? (
            <NavLink
              to={renterUrl}
              className="font-semibold text-black hover:text-sky-500"
            >
              {vehicleRecord.nameRenter}
            </NavLink>
          ) : (
            vehicleRecord.nameRenter
          )}
        </h2>

        <div className="flex flex-col">
          <section className="flex flex-col sm:flex-row gap-4 ">
            <div>
              {vehicleData ? (
                <CardStartMaintenance
                  data={vehicleRecord}
                  onClick={handleToggleDelivered}
                />
              ) : (
                <Suspense />
              )}
              {showStartDetails && (
                <VehicleStartMaintenanceDetails
                  data={vehicleRecord!}
                  onClose={handleCloseStartMaintenance}
                />
              )}
            </div>
            <div>
              {vehicleData ? (
                <CardEndMaintenance
                  data={vehicleRecord}
                  onClick={handleToggleEnd}
                />
              ) : (
                <Suspense />
              )}
              {showEndDetails && (
                <VehicleEndMaintenanceDetails
                  data={vehicleRecord!}
                  onClose={handleCloseEndMaintenance}
                />
              )}
              {maintenances.find(el => vehicleData.maintenanceId === el._id)?.odometer && <div className="p-2">
                <p>Odômetro: {maintenances.find(el => vehicleData.maintenanceId === el._id)?.odometer}</p>
                <p>Próxima Preventiva: {Number(maintenances.find(el => vehicleData.maintenanceId === el._id)?.odometer) + 5000}</p>
              </div>
              }
            </div>
          </section>
          <section className="mt-4">
            <div className="flex flex-col gap-2">
              {vehicleData.forecastMaintenance && (
                <div className="grid grid-cols-2">
                  <h4 className="relative text-center font-semibold mb-2 text-1xl col-span-2">
                    Próxima Manutenção
                    {isFirstRecord &&
                      (permissions?.includes("edit:editLocavibe") ? (
                        <span className="absolute right-0 top-1/2 transform -translate-y-1/2">
                          <FaPencil
                            onClick={() => setShowModal(!showModal)}
                            className="cursor-pointer"
                          />
                        </span>
                      ) : null)}
                  </h4>
                  <div className="flex flex-row w-full">
                    <span
                      className={`p-2 border border-gray/50 border-r-0 flex items-center bg-white/50 w-1/3`}
                    >
                      Data:
                    </span>
                    <span
                      className={`p-2 rounded-r-md border border-gray/50 border-l-0 flex items-center bg-white/50 w-2/3`}
                    >
                      {vehicleData.forecastMaintenance &&
                        new Date(
                          vehicleData.forecastMaintenance.dateNextMaintenance
                        ).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          timeZone: "UTC",
                        })}
                    </span>
                  </div>
                  <div className="flex flex-row w-full">
                    <span
                      className={`p-2 border border-gray/50 border-r-0 flex items-center bg-white/50 w-1/3`}
                    >
                      Hodômetro:
                    </span>
                    <span
                      className={`p-2 rounded-r-md border border-gray/50 border-l-0 flex items-center bg-white/50 w-2/3`}
                    >
                      {String(vehicleData.forecastMaintenance.odometer)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
      {showModal && vehicleData.forecastMaintenance && (
        <ModalForecastMaintenanceEdit
          setHasUpdated={setHasUpdated}
          onClose={() => setShowModal(!showModal)}
          data={vehicleData.forecastMaintenance}
          maintenanceId={vehicleData.maintenanceId}
        ></ModalForecastMaintenanceEdit>
      )}
    </section>
  );
}
